export default __webpack_public_path__ + "static/media/fpb50000.5c8ca107.png";